import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=b0b6dcfc&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6dcfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0b6dcfc')) {
      api.createRecord('b0b6dcfc', component.options)
    } else {
      api.reload('b0b6dcfc', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=b0b6dcfc&scoped=true&", function () {
      api.rerender('b0b6dcfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fZAVWBcFragU/JS/comp/Voucher-Unit.vue"
export default component.exports